import { FnDateFormatter } from './date';

declare global {
    interface Date {
        formatter(formatterString: any, langId?: any): any;

        getFormattedTime(): any;

        addDays(days: number, useThis?: boolean): Date;

        isToday(): boolean;

        clone(): Date;

        isAnotherMonth(date: Date): boolean;

        isWeekend(): boolean;

        isSameDate(date: Date): boolean;

        getCurrentDate(): any;

        offsetMntsToBusiDate(minutes: any): any;

        timeForZoneOffset(offset: any): any;

        getMinutesOfDay(): any;

        getWeek(): any;

        dateOffset(offset: any): any;

        getNextPrevDates(numOfDays: any): any;

        getFormattedDate(): string;

        isFutureDate(date?: Date): boolean;
    }

    interface String {
        startsWith(str: string): any;

        getFirstChar(): any;

        removeSpaces(): any;

        endsWith(suffix: any): any;

        codePointBefore(str: string): any;

        insertCharAt(index: number, character: any): any;

        //replaceAll(str1: any, str2: any, ignore: any): any;

        capitalizeFirstLetter(): any;

        includes(): any;

        contains(str: any, startIndex: any): any;
    }

    interface Window {
        File: any;
        FileReader: any;
        FileList: any;
    }
}
// All String Prototype //

String.prototype.startsWith = function (str: any): boolean {
    return this.indexOf(str) === 0;
};

String.prototype.getFirstChar = function (): any {
    return this[0];
};

String.prototype.removeSpaces = function () {
    return this.replace(/\s+/g, '');
};

String.prototype.endsWith = function (suffix: any): any {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};

String.prototype.codePointBefore = function (strVal: any): any {
    return this.substring(0, this.indexOf(strVal));
};

String.prototype.insertCharAt = function (index: number, character: any): any {
    return (
        this.substring(0, index) + character + this.substring(index + character.length)
    );
};

// String.prototype.replaceAll = function (
// 	str1: any,
// 	str2: any,
// 	ignore: any
// ): any {
// 	return this.replace(
// 		new RegExp(
// 			str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, '\\$&'),
// 			ignore ? 'gi' : 'g'
// 		),
// 		typeof str2 === 'string' ? str2.replace(/\$/g, '$$$$') : str2
// 	);
// };

String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// String.prototype.includes = function (search:string,position?:number):boolean {

//     if (position === undefined) { position = 0; }
//     return this.indexOf(search, position) !== -1;

// };



String.prototype.contains = function (str: any, startIndex: any) {
    return ''.indexOf.call(this, str, startIndex) !== -1;
};

// All Date Prototype //

Date.prototype.formatter = function (
    formatterString: any,
    langId?: any
): string {
    return new FnDateFormatter().format(this, formatterString, langId);
};

Date.prototype.getCurrentDate = function () {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate());
};


Date.prototype.offsetMntsToBusiDate = function (minutes: any) {
    const date = new Date(this.getFullYear(), this.getMonth(), this.getDate());
    date.setMinutes(minutes);
    return date;
};

Date.prototype.timeForZoneOffset = function (offset: any) {
    const utc = this.getTime() + this.getTimezoneOffset() * 60000;
    const newDate = new Date(utc + 3600000 * offset);
    return newDate;
};

Date.prototype.getWeek = function (): any {
    const onejan: Date = new Date(this.getFullYear(), 0, 1);
    let d1: any = this;
    let d2: any = onejan;

    return Math.ceil(((d1 - d2) / 86400000 + onejan.getDay() + 1) / 7);
};

Date.prototype.dateOffset = function (offset: any): any {
    this.setDate(this.getDate() + offset);
    return this;
};

Date.prototype.getNextPrevDates = function (numOfDays: any): any {
    const nextDate = this;
    if (numOfDays === undefined || numOfDays === 0) {
        return nextDate;
    }
    return new Date(nextDate.setDate(nextDate.getDate() + numOfDays));
};

Date.prototype.getMinutesOfDay = function () {
    return this.getHours() * 60 + this.getMinutes();
};

Date.prototype.getFormattedTime = function (): any {
    return this.formatter('RIB');
};

Date.prototype.addDays = function (days: number): Date {
    if (!days) {
        return this;
    }
    const date = this;
    date.setDate(date.getDate() + days);

    return date;
};

Date.prototype.isToday = function (): boolean {
    return this.isSameDate(new Date());
};

Date.prototype.clone = function (): Date {
    return new Date(+this);
};

Date.prototype.isAnotherMonth = function (date: Date): boolean {
    return date && this.getMonth() !== date.getMonth();
};

Date.prototype.isWeekend = function (): boolean {
    return this.getDay() === 0 || this.getDay() === 6;
};

Date.prototype.isFutureDate = function (date?: Date): boolean {
    let currentDate = date || new Date();
    return this.getTime() > currentDate.getTime();
};


Date.prototype.isSameDate = function (date: Date): boolean {
    return (
        date &&
        this.getFullYear() === date.getFullYear() &&
        this.getMonth() === date.getMonth() &&
        this.getDate() === date.getDate()
    );
};
Date.prototype.getFormattedDate = function () {
    return this.formatter('m/d/Y');
};

export default {};
